export const subDomain = process.env.REACT_APP_BASE_NAME;

export const redirectTo = (path) => {
  sessionStorage.setItem('last-page', window.location.pathname);
  window.location = `${subDomain}${path}`;
};
